import {
  FormEvent,
  FunctionComponent,
  useState,
  useRef,
  useCallback,
  ChangeEvent,
} from 'react'
import { useHistory } from 'react-router'
import services from '../../auth-services'
import useStyles from './styles'
import ReCAPTCHA from 'react-google-recaptcha'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import {
  Text,
  Button,
  toast,
  InputPassword,
  getTheme,
} from '@conexasaude/conexa-hero'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'

interface ConfirmPasswordProps {
  onConfirm: () => void
}

const ConfirmPassword: FunctionComponent<ConfirmPasswordProps> = ({
  onConfirm,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [password, setPassword] = useState('')
  const recaptchaRef = useRef<ReCAPTCHA>(null)
  const theme = getTheme()

  const { push } = useHistory()

  const styles = useStyles()

  const handleVerifyPassword = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsLoading(true)
    try {
      const token = await recaptchaRef.current.executeAsync()
      const verified = await services.verifyPassword(password, token)

      if (verified) {
        onConfirm()
      } else {
        toast({
          message: 'Senha incorreta',
          variant: 'error',
          autoCloseDuration: 5000,
        })
        recaptchaRef.current.reset()
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.msg || err?.response?.msg || err.message

      toast({
        message: errorMessage,
        variant: 'error',
        autoCloseDuration: 5000,
      })
      recaptchaRef.current.reset()
    }
    setIsLoading(false)
  }

  const handlePasswordChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setPassword(event.target.value)
    },
    [],
  )

  const goToForgotPassword = useCallback(() => {
    push('/esqueci-senha')
  }, [push])

  return (
    <HeroWrapper>
      <form css={styles.container} onSubmit={handleVerifyPassword}>
        <Text variant="headingLarge" color={theme.colors.neutral[400]}>
          Qual é a sua senha atual?
        </Text>
        <Text renderAs="p">
          Para criar uma nova senha, nos informe a senha que você utiliza
          atualmente.
        </Text>

        <InputPassword
          label="Senha atual"
          placeholder="Informe a senha atual"
          value={password}
          onChange={handlePasswordChange}
          fullWidth
        />

        <div css={styles.buttonWrapper}>
          <Button busy={isLoading} disabled={!password.length} fullWidth>
            Confirmar senha
          </Button>
        </div>

        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        />

        <Text
          renderAs="span"
          variant="linkUnderline"
          css={styles.linkWrapper}
          onClick={goToForgotPassword}
        >
          Esqueci minha senha
        </Text>
      </form>

      <Text
        renderAs="span"
        variant="linkUnderline"
        css={styles.LinkSupport}
        onClick={openWhatsappSupport}
      >
        Precisa de ajuda?
      </Text>
    </HeroWrapper>
  )
}

export { ConfirmPassword }
